import { Component } from '@angular/core';
import {ModalController, NavController, NavParams, ViewController} from "ionic-angular";
import {ItemPage} from "../item-details/item-details";
import {Storage} from "@ionic/storage";
import {StockcartManager} from "../../providers/stockcart-manager";
import {STOCKCART} from "../../providers/data";
import {GVLogger} from "../../services/gv-logger";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {Constants} from "../../providers/config";

@Component({
  selector: 'page-receive-stock-popup',
  templateUrl: 'receive-stock-popup.html',
})
export class ReceiveStockPopupPage {
  items = [];
  cacheImages:any;
  private product: any;
  constants = Constants;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private storage:Storage,
              private stockCartManager: StockcartManager,
              private modalController:ModalController,
              private gVLogger: GVLogger,
              private cartManager: CartManager,
              public api:Api) {
    this.items.push(this.navParams.get('item'));
    this.product = this.navParams.get('item');
    this.gVLogger.log("product from navparams "  + JSON.stringify(this.product) );

    this.product.quantity = this.product.totalQuantityShipmentNotice;
    let existingProdQuantity = this.stockCartManager.getQuantityIfProductAlreadyAdded(this.product);

    if(existingProdQuantity !== null){
      this.product.quantity = existingProdQuantity;
    }


    this.storage.get("cacheImages").then((cache)=>{
      this.cacheImages = cache;
    });
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReceiveStockPopupPage');
  }

  close(){
    this.viewCtrl.dismiss();
  }

  addProductToCartOnOk(){
    this.viewCtrl.dismiss(this.product);
  }

  gotoSingleView(product){
    this.api.get("product/" + product.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status === "200"){
        product.description = data.data.description;
      }
    })
    this.navCtrl.push(ItemPage, {item: product, "status" : "fromReceiveStock"});
  }

  // makeImageURL(dimensions,item){
  //   return this.stockCartManager.makeImageURL(dimensions,item);
  // }

  makeImageURL(dimensions,item){
    if(item.productImagesDTO[0].name === "dummy" || item.productImagesDTO[0].name === "dummy"){
      if(this.constants.isWebstore){
        return this.cartManager.makeNANImageURLFromImage(dimensions);
      }
      else{
        return "./assets/img/dummy-"+dimensions+".png";
      }
    }else{
      this.gVLogger.log("UUUUUUUURRRRRrl " + this.cartManager.makeImageURL(dimensions,item));
      return this.cartManager.makeImageURL(dimensions,item);
    }
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  removeProductFromCart(product){

    this.stockCartManager.removeOneNew(product);

    // if(product.quantity < 0){
    //   this.gVLogger.log("if executed");
    //   this.stockCartManager.deleteProductFromCart(product);
    // }

    this.refreshTotalPrice();
  }

  refreshTotalPrice(){
    // this.cart = STOCKCART;
    // let temp:number = 0;
    // for(let item of this.cart.items){
    //   temp =  temp +  Number(item.quantity);
    // }
    // this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    // this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    // this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }

  updateProductInCart(product){
    this.gVLogger.log("update called.....");
    if(String(product.quantity) !=""){
      if(String(product.quantity).match(/^\d+$/)){
        this.stockCartManager.updateCartNewPopup(product);
      }else{
        product.quantity = Number(product.quantity);
        this.stockCartManager.updateCartNewPopup(product);
      }
    }else{
      product.quantity = Number(product.quantity);
      this.stockCartManager.updateCartNewPopup(product);
    }
    this.refreshTotalPrice();

  }

  addProductToCart(item){
    this.stockCartManager.addProductToCartPopup(item);
    this.refreshTotalPrice();
    return true;
  }

  getFallBackImage(dim) {
    if (this.constants.isWebstore) {
      return this.cartManager.makeNANImageURLFromImage(dim);

    } else {
      return "./assets/img/dummy-" + dim + ".png";
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/receive-stock-popup/receive-stock-popup.ts